import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <FooterContainer>
      {/* <FooterNav>
        <Link to="/terms-of-use">Terms of Use</Link>
        <span>|</span>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <span>|</span>
        <Link to="/disclaimer">Disclaimer</Link>
      </FooterNav> */}
      <p className="text-white rightsParaText mb-0"> ©2025. <Link to="https://nutrifytoday.com" target="_blank">NutrifyToday</Link>. All Rights Reserved. </p>
    </FooterContainer>
  );
};

export default Footer;

const FooterContainer = styled.footer`
  width: 100%;
  background: #43141d; /* Using a dark brown from your existing header/homepage for consistency */
  color: #fff;
  ${'' /* margin-top: 100px; */}
  padding: 15px 0;
  text-align: center;
  font-size: 0.95rem;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  .rightsParaText{
    a{
      text-decoration: none;
      color: var(--secondary-color);
    }
  }
`;

// const FooterNav = styled.nav`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   gap: 20px; /* Space between items */

//   a {
//     color: rgb(255, 255, 255); /* Using your accent orange for links */
//     text-decoration: none;
//     transition: color 0.2s ease-in-out;

//     &:hover {
//       color: #fff; /* White on hover for contrast */
//     }
//   }

//   span {
//     color: #fff; /* Separator color */
//     /* Adjust margin for better spacing if needed */
//     margin: 0 -5px; /* Pull separators closer to links */
//   }
// `;
